import React from "react";
import { Box, Text, Link, themeGet } from "@fuegokit/react";
import Avatar from "../Avatar";
import { format } from "date-fns";
import uniqBy from "lodash.uniqby";
import pluralize from "pluralize";

import { generatedId } from "../../lib/utils";

const Contributors = ({ contributors }) => {
  const uniqueContributors = uniqBy(contributors, "login");
  const latestContributor = uniqueContributors[0] || {};
  // jest is throwing an inexplicable error in unit tests about key prop
  return (
    <React.Fragment key={generatedId()}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            py: 1,
            display: "flex",
            alignItems: "center",
          }}
        >
          {uniqueContributors.length >= 2 && (
            <Text sx={{ mr: 2, color: "text.subtlest" }}>
              {uniqueContributors.length}{" "}
              {pluralize("contributor", uniqueContributors.length)}
            </Text>
          )}
          <Box
            sx={{
              py: 1,
              display: "flex",
              alignItems: "center",
              flexDirection: "row-reverse",
            }}
          >
            {uniqueContributors.reverse().map((contributor) => {
              return (
                <Box key={`${contributor}-${generatedId()}`}>
                  <Link
                    href={`https://bitbucket.org/${contributor.uuid.replace(
                      /['"]+/g,
                      ""
                    )}`}
                    sx={{
                      mr: 2,
                      lineHeight: "condensedUltra",
                    }}
                  >
                    {" "}
                    <Box sx={{ margin: 0, mr: -3 }}>
                      <Avatar
                        src={contributor.avatarUrl.href}
                        alt={contributor.login}
                        size={24}
                      />
                    </Box>
                  </Link>
                </Box>
              );
            })}
          </Box>
        </Box>
        {latestContributor.latestCommit ? (
          <Text sx={{ color: "text.subtlest" }}>
            {" "}
            Last edited by{" "}
            <Link
              subtle
              href={`https://bitbucket.org/${latestContributor.uuid.replace(
                /['"]+/g,
                ""
              )}`}
            >
              {latestContributor.displayName}
            </Link>{" "}
            on{" "}
            {format(new Date(latestContributor.latestCommit.date), "MMMM d, y")}
          </Text>
        ) : null}
      </Box>
    </React.Fragment>
  );
};

export default Contributors;
